export function dataUrlToBase64(dataUrl: string) {
  return dataUrl.includes(',') ? (dataUrl.split(',')[1] ?? '') : dataUrl
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(dataUrlToBase64(String(reader.result || '')))
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
}
